/* =============================================================================
   FTB CART DRAWER — Vanilla JS, no dependencies.
   Reads settings from #ftb-cd-config (set by sections/ftb-cart-drawer.liquid).
   Listens for 'cart:updated' CustomEvent dispatched by ftb-cart.js.
   ============================================================================= */

(function () {
  'use strict';

  /* ── Helpers ──────────────────────────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }

  function fmt(pence) { return '£' + (pence / 100).toFixed(2); }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Settings — read from section config element ──────────────────────────── */
  function getSettings() {
    var cfg = qs('#ftb-cd-config');
    if (!cfg) {
      return {
        timerEnabled:       true,
        timerMinutes:       10,
        timerText:          'Your basket is reserved for',
        showProgress:       true,
        deliveryThreshold:  4500,
        upsellHeading:      'People also added',
        upsellCollection:   '',
        upsellLimit:        4,
        autoOpen:           true,
        showPaymentIcons:   true
      };
    }
    return {
      timerEnabled:      cfg.dataset.timerEnabled !== 'false',
      timerMinutes:      parseInt(cfg.dataset.timerMinutes, 10) || 10,
      timerText:         cfg.dataset.timerText || 'Your basket is reserved for',
      showProgress:      cfg.dataset.showProgress !== 'false',
      deliveryThreshold: parseInt(cfg.dataset.deliveryThreshold, 10) || 4500,
      upsellHeading:     cfg.dataset.upsellHeading || 'People also added',
      upsellCollection:  cfg.dataset.upsellCollection || '',
      upsellLimit:       parseInt(cfg.dataset.upsellLimit, 10) || 4,
      autoOpen:          cfg.dataset.autoOpen !== 'false',
      showPaymentIcons:  cfg.dataset.showPaymentIcons !== 'false'
    };
  }

  /* ── Cart API ─────────────────────────────────────────────────────────────── */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); });
  }

  function changeCartLine(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); });
  }

  function addItemToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); });
  }

  /* ── State ────────────────────────────────────────────────────────────────── */
  var isOpen = false;
  var timerInterval = null;
  var TIMER_KEY = 'ftb_cart_timer_expiry';

  /* ── Kit discount note ────────────────────────────────────────────────────── */
  function updateKitDiscountNote() {
    var noteEl = qs('#ftb-cd-kit-discount-note');
    if (!noteEl) return;
    var code = '';
    try { code = sessionStorage.getItem('ftb_kit_discount') || ''; } catch (e) {}
    noteEl.style.display = code ? '' : 'none';
  }

  /* ── Open / Close ─────────────────────────────────────────────────────────── */
  function openDrawer() {
    var drawer  = qs('#ftb-cd');
    var overlay = qs('#ftb-cd-overlay');
    if (!drawer || !overlay || isOpen) return;

    isOpen = true;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ftb-body-locked');
    updateKitDiscountNote();

    setTimeout(function () {
      var closeBtn = qs('#ftb-cd-close');
      if (closeBtn) closeBtn.focus();
    }, 300);

    fetchCart()
      .then(function (cart) { renderDrawer(cart); loadUpsells(cart); })
      .catch(function () {});

    startTimer();
  }

  function closeDrawer() {
    var drawer  = qs('#ftb-cd');
    var overlay = qs('#ftb-cd-overlay');
    if (!drawer || !overlay || !isOpen) return;

    isOpen = false;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ftb-body-locked');

    var opener = qs('[data-open-cart-drawer]');
    if (opener) opener.focus();
  }

  /* ── Progress bar ─────────────────────────────────────────────────────────── */
  function updateProgress(totalPence) {
    var msgEl  = qs('#ftb-cd-progress-msg');
    var fillEl = qs('#ftb-cd-progress-fill');
    if (!msgEl || !fillEl) return;

    var threshold = getSettings().deliveryThreshold;
    var pct = Math.min(100, (totalPence / threshold) * 100);
    fillEl.style.width = pct + '%';

    if (totalPence >= threshold) {
      msgEl.innerHTML = '&#x2713; <strong>Free UK delivery unlocked</strong>';
      fillEl.classList.add('is-full');
    } else {
      var gap = ((threshold - totalPence) / 100).toFixed(2);
      msgEl.innerHTML = 'Add <strong>£' + gap + '</strong> more for free UK delivery';
      fillEl.classList.remove('is-full');
    }
  }

  /* ── Render full drawer ───────────────────────────────────────────────────── */
  function renderDrawer(cart) {
    document.querySelectorAll('.ftb-cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });

    var subEl = qs('#ftb-cd-subtotal');
    if (subEl) subEl.textContent = fmt(cart.total_price);

    updateProgress(cart.total_price);

    var bodyEl = qs('#ftb-cd-body');
    var footEl = qs('#ftb-cd-foot');
    if (!bodyEl) return;

    if (!cart.items || cart.items.length === 0) {
      bodyEl.innerHTML = renderEmpty();
      if (footEl) footEl.hidden = true;
    } else {
      if (footEl) footEl.hidden = false;
      bodyEl.innerHTML = cart.items.map(function (item, i) {
        return renderItem(item, i + 1);
      }).join('');
    }
  }

  /* ── Cart item HTML ───────────────────────────────────────────────────────── */
  function renderItem(item, line) {
    var imgSrc = item.image
      ? String(item.image).replace(/^http:\/\//, 'https://')
      : '';
    var imgHtml = imgSrc
      ? '<img src="' + esc(imgSrc) + '" alt="' + esc(item.product_title) + '" loading="lazy" width="72" height="72">'
      : '<div class="ftb-cd-item__no-img"></div>';

    var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="ftb-cd-item__variant">' + esc(item.variant_title) + '</p>'
      : '';

    /* Show unit price when qty > 1 so line total is never mistaken for unit price */
    var unitPriceHtml = item.quantity > 1
      ? '<p class="ftb-cd-item__unit-price">' + fmt(item.final_price) + ' each</p>'
      : '';

    return '<div class="ftb-cd-item" data-line="' + line + '">'
      + '<div class="ftb-cd-item__img">' + imgHtml + '</div>'
      + '<div class="ftb-cd-item__info">'
      +   '<p class="ftb-cd-item__title">' + esc(item.product_title) + '</p>'
      +   variantHtml
      +   unitPriceHtml
      +   '<div class="ftb-cd-item__foot">'
      +     '<div class="ftb-cd-item__qty">'
      +       '<button type="button" class="ftb-cd-item__qty-btn" data-line="' + line + '" data-delta="-1" aria-label="Decrease quantity">&#x2212;</button>'
      +       '<span class="ftb-cd-item__qty-num">' + item.quantity + '</span>'
      +       '<button type="button" class="ftb-cd-item__qty-btn" data-line="' + line + '" data-delta="1" aria-label="Increase quantity">&#x2b;</button>'
      +     '</div>'
      +     '<div class="ftb-cd-item__right">'
      +       '<p class="ftb-cd-item__price">' + fmt(item.final_line_price) + '</p>'
      +       '<button type="button" class="ftb-cd-item__remove" data-line="' + line + '" aria-label="Remove ' + esc(item.product_title) + '">Remove</button>'
      +     '</div>'
      +   '</div>'
      + '</div>'
      + '</div>';
  }

  /* ── Empty cart state ─────────────────────────────────────────────────────── */
  function renderEmpty() {
    return '<div class="ftb-cd-empty">'
      + '<p class="ftb-cd-empty__headline">YOUR BASKET IS EMPTY</p>'
      + '<p class="ftb-cd-empty__sub">No beast leaves the den unprepared.</p>'
      + '<a href="/collections/all" class="ftb-cd-empty__cta">SHOP ALL PRODUCTS</a>'
      + '</div>';
  }

  /* ── Upsell image URL ────────────────────────────────────────────────────── */
  function upsellImageSrc(product) {
    var src = '';
    /* featured_image is the most reliable key in both recommendations and collection APIs */
    if (product.featured_image) {
      src = typeof product.featured_image === 'string'
        ? product.featured_image
        : (product.featured_image.src || '');
    }
    if (!src && product.images && product.images.length > 0) {
      src = product.images[0].src || '';
    }
    if (!src) return '';

    /* Ensure HTTPS */
    src = src.replace(/^http:\/\//, 'https://');

    /* Inject a 160×160 size variant.
       Shopify CDN format: filename.ext?v=N  →  filename_160x160.ext?v=N
       Remove any existing size suffix first to avoid double-sizing. */
    src = src.replace(/(_\d+x\d*(_crop_\w+)?)?\.(jpg|jpeg|png|gif|webp)(\?|$)/i,
                      '_160x160.$3$4');
    return src;
  }

  /* ── Upsell carousel ──────────────────────────────────────────────────────── */
  function loadUpsells(cart) {
    var el = qs('#ftb-cd-upsells');
    if (!el) return;

    /* Capture settings before any async work — avoids variable shadowing */
    var settings    = getSettings();
    var collection  = settings.upsellCollection;
    var limit       = parseInt(el.dataset.limit, 10) || settings.upsellLimit || 4;
    var productId   = cart.items && cart.items.length > 0 ? cart.items[0].product_id : null;
    /* IDs already in cart — exclude them from upsells */
    var cartIds     = (cart.items || []).map(function (i) { return i.product_id; });

    if (productId) {
      fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + (limit + cartIds.length) + '&intent=related')
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (resp) {
          /* resp is the API response — NOT settings. Use our captured variables. */
          var products = (resp.products || [])
            .filter(function (p) { return p.available && cartIds.indexOf(p.id) === -1; })
            .slice(0, limit);

          if (products.length > 0) {
            renderUpsells(products, el, settings.upsellHeading);
          } else {
            tryCollectionFallback(collection, limit, cartIds, el, settings.upsellHeading);
          }
        })
        .catch(function () {
          tryCollectionFallback(collection, limit, cartIds, el, settings.upsellHeading);
        });
    } else if (collection) {
      tryCollectionFallback(collection, limit, cartIds, el, settings.upsellHeading);
    } else {
      el.style.display = 'none';
    }
  }

  function tryCollectionFallback(handle, limit, cartIds, el, heading) {
    if (!handle) { el.style.display = 'none'; return; }
    /* Fetch more than needed so we can filter out cart items */
    fetch('/collections/' + handle + '/products.json?limit=' + (limit + cartIds.length + 4))
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (resp) {
        var products = (resp.products || [])
          .filter(function (p) { return p.available && cartIds.indexOf(p.id) === -1; })
          .slice(0, limit);
        if (products.length > 0) {
          renderUpsells(products, el, heading);
        } else {
          el.style.display = 'none';
        }
      })
      .catch(function () { el.style.display = 'none'; });
  }

  function renderUpsells(products, el, heading) {
    var html = '<div class="ftb-cd-upsells__head">'
      + '<p class="ftb-eyebrow">' + esc(heading || 'People also added') + '</p>'
      + '</div>'
      + '<div class="ftb-cd-upsells__track">';

    products.forEach(function (p) {
      /* Always use the first available variant — avoids variant-picker complexity */
      var variant = null;
      (p.variants || []).some(function (v) {
        if (v.available) { variant = v; return true; }
        return false;
      });
      if (!variant && p.variants && p.variants.length > 0) variant = p.variants[0];
      if (!variant) return;

      var imgSrc  = upsellImageSrc(p);
      var imgHtml = imgSrc
        ? '<img src="' + esc(imgSrc) + '" alt="' + esc(p.title) + '" loading="lazy" width="80" height="80">'
        : '<div class="ftb-cd-upsell__no-img"></div>';

      html += '<div class="ftb-cd-upsell">'
        + '<div class="ftb-cd-upsell__img">' + imgHtml + '</div>'
        + '<div class="ftb-cd-upsell__info">'
        +   '<p class="ftb-cd-upsell__title">' + esc(p.title) + '</p>'
        +   '<p class="ftb-cd-upsell__price">' + fmt(variant.price) + '</p>'
        + '</div>'
        /* Dedicated class — handled by drawer JS, not the global data-quick-add handler */
        + '<button type="button" class="ftb-cd-upsell__add ftb-cd-upsell__add-btn"'
        +   ' data-variant-id="' + variant.id + '"'
        +   ' aria-label="Add ' + esc(p.title) + ' to basket"'
        + '>+</button>'
        + '</div>';
    });

    html += '</div>';
    el.innerHTML = html;
    el.style.display = '';
  }

  /* ── Reservation timer ────────────────────────────────────────────────────── */
  function startTimer() {
    var s = getSettings();
    var timerEl = qs('#ftb-cd-timer');
    if (!timerEl) return;           /* Element absent when setting disabled in Liquid */
    if (!s.timerEnabled) {
      timerEl.style.display = 'none';
      return;
    }

    var now    = Date.now();
    var expiry = parseInt(localStorage.getItem(TIMER_KEY) || '0', 10);

    if (!expiry || expiry <= now) {
      expiry = now + s.timerMinutes * 60 * 1000;
      try { localStorage.setItem(TIMER_KEY, String(expiry)); } catch (e) {}
    }

    clearInterval(timerInterval);

    function tick() {
      var remaining = Math.max(0, expiry - Date.now());
      if (remaining === 0) {
        /* Timer expired: show a brief "ending soon" message, then hide */
        timerEl.textContent = 'Reserved time ending soon';
        timerEl.style.display = 'block';   /* ← explicit block, not '' which reverts to CSS display:none */
        clearInterval(timerInterval);
        try { localStorage.removeItem(TIMER_KEY); } catch (e) {}
        setTimeout(function () { timerEl.style.display = 'none'; }, 3000);
        return;
      }
      var mins = Math.floor(remaining / 60000);
      var secs = Math.floor((remaining % 60000) / 1000);
      timerEl.textContent = s.timerText + ' ' + mins + ':' + (secs < 10 ? '0' : '') + secs;
      timerEl.style.display = 'block';     /* ← explicit block — DO NOT use '' here (CSS default is display:none) */
    }

    tick();
    timerInterval = setInterval(tick, 1000);
  }

  /* ── Item interactions (qty, remove, upsell add) ─────────────────────────── */
  function initItemInteractions() {
    var drawer = qs('#ftb-cd');
    if (!drawer) return;

    drawer.addEventListener('click', function (e) {

      /* ── Qty buttons ── */
      var qtyBtn = e.target.closest('.ftb-cd-item__qty-btn');
      if (qtyBtn && !qtyBtn.disabled) {
        e.preventDefault();
        var line      = parseInt(qtyBtn.dataset.line,  10);
        var delta     = parseInt(qtyBtn.dataset.delta, 10);
        var numEl     = qtyBtn.closest('.ftb-cd-item__qty').querySelector('.ftb-cd-item__qty-num');
        var currentQty = numEl ? parseInt(numEl.textContent, 10) : 1;
        var newQty     = Math.max(0, currentQty + delta);
        var itemEl     = qtyBtn.closest('.ftb-cd-item');
        if (itemEl) itemEl.classList.add('is-loading');

        changeCartLine(line, newQty)
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          })
          .catch(function () {
            if (itemEl) itemEl.classList.remove('is-loading');
          });
        return;
      }

      /* ── Remove buttons ── */
      var removeBtn = e.target.closest('.ftb-cd-item__remove');
      if (removeBtn && !removeBtn.disabled) {
        e.preventDefault();
        var line    = parseInt(removeBtn.dataset.line, 10);
        var itemEl2 = removeBtn.closest('.ftb-cd-item');
        if (itemEl2) itemEl2.classList.add('is-loading');

        changeCartLine(line, 0)
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          })
          .catch(function () {
            if (itemEl2) itemEl2.classList.remove('is-loading');
          });
        return;
      }

      /* ── Upsell add buttons ──
         Handled here (NOT via global data-quick-add) so we can:
         - preventDefault/stopPropagation to keep drawer open
         - use type="button" to prevent form submit
         - show "+" consistently on all screen sizes */
      var upsellBtn = e.target.closest('.ftb-cd-upsell__add-btn');
      if (upsellBtn && !upsellBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = upsellBtn.dataset.variantId;
        if (!variantId) return;

        upsellBtn.disabled = true;
        var origLabel = upsellBtn.textContent;
        upsellBtn.textContent = '…';

        addItemToCart(variantId, 1)
          .then(function () { return fetchCart(); })
          .then(function (cart) {
            upsellBtn.textContent = '✓';
            setTimeout(function () {
              upsellBtn.disabled = false;
              upsellBtn.textContent = origLabel;
            }, 1200);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          })
          .catch(function () {
            upsellBtn.disabled = false;
            upsellBtn.textContent = origLabel;
          });
      }
    });
  }

  /* ── Global event wiring ──────────────────────────────────────────────────── */
  function initEvents() {
    /* Open drawer */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-cart-drawer]')) {
        e.preventDefault();
        openDrawer();
      }
    });

    /* Close on overlay click */
    var overlay = qs('#ftb-cd-overlay');
    if (overlay) overlay.addEventListener('click', closeDrawer);

    /* Close button */
    document.addEventListener('click', function (e) {
      if (e.target.closest('#ftb-cd-close')) closeDrawer();
    });

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && isOpen) closeDrawer();
    });

    /* cart:updated — fired by ftb-cart.js after every cart mutation */
    document.addEventListener('cart:updated', function (e) {
      var cart = e.detail;
      updateProgress(cart.total_price);
      if (isOpen) {
        renderDrawer(cart);
        loadUpsells(cart);
      }
    });

    /* cart:item-added — fired by ftb-cart.js after ATC form submit */
    document.addEventListener('cart:item-added', function () {
      if (!getSettings().autoOpen) return;
      if (!isOpen) openDrawer();
    });

    /* cart:kit-discount — fired by ftb-bundle.js when a kit is added with a discount code */
    document.addEventListener('cart:kit-discount', function () {
      updateKitDiscountNote();
    });

    /* Checkout form — apply stored kit discount code if present */
    var checkoutBtn = qs('#ftb-cd-checkout');
    var checkoutForm = checkoutBtn ? checkoutBtn.closest('form') : null;
    if (checkoutForm) {
      checkoutForm.addEventListener('submit', function (e) {
        var code = '';
        try { code = sessionStorage.getItem('ftb_kit_discount') || ''; } catch (ex) {}
        if (code) {
          e.preventDefault();
          try { sessionStorage.removeItem('ftb_kit_discount'); } catch (ex) {}
          window.location.href = '/checkout?discount=' + encodeURIComponent(code);
        }
      });
    }

    /* Mouse-wheel → horizontal scroll on upsell track.
       Trackpad two-finger swipe already works via overflow-x: auto.
       This converts a vertical mouse-wheel delta to horizontal for desktop mice. */
    var drawerEl = qs('#ftb-cd');
    if (drawerEl) {
      drawerEl.addEventListener('wheel', function (e) {
        var track = e.target.closest('.ftb-cd-upsells__track');
        if (!track) return;
        if (e.deltaY !== 0 && e.deltaX === 0) {
          e.preventDefault();
          track.scrollLeft += e.deltaY;
        }
      }, { passive: false });
    }
  }

  /* ── Init ─────────────────────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    var init = window.FTBInit || {};
    if (typeof init.cartTotal === 'number') updateProgress(init.cartTotal);

    initEvents();
    initItemInteractions();
  });

  window.FTBDrawer = { open: openDrawer, close: closeDrawer };

})();
